import React from 'react';
import type { VisualFractionPart } from '../types';
import { getInteractiveProps } from './part-interactions';

interface BarShapeProps {
  parts: VisualFractionPart[];
  divisions: number;
  orientation: 'horizontal' | 'vertical';
  onPartClick: (index: number) => void;
}

export const BarShape: React.FC<BarShapeProps> = ({
  parts,
  divisions,
  orientation,
  onPartClick,
}) => {
  const renderedParts = orientation === 'vertical' ? [...parts].reverse() : parts;

  return (
    <div
      className={`visual-fraction-widget__parts${
        orientation === 'vertical'
          ? ' visual-fraction-widget__parts--vertical'
          : ' visual-fraction-widget__parts--horizontal'
      }`}
      style={{ '--visual-fraction-divisions': divisions } as React.CSSProperties}
    >
      {renderedParts.map(part => (
        <div
          key={part.index}
          className={part.className}
          style={part.style}
          {...getInteractiveProps(part, onPartClick)}
        />
      ))}
    </div>
  );
};

BarShape.displayName = 'BarShape';
